import IndividualsDirectories from 'pages/individuals'
export default IndividualsDirectories
